import styled from 'styled-components';
import { Text16Regular } from '../../../components/utils/Text/Text.styles';

export const PageContainer = styled.div`
  max-height: 100%;
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  gap: 1.2rem;
  padding: 1.6rem;
  max-height: calc(100% - 6.8rem);
  background: #f9fafb;
`;

export const ListItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  padding: 1.6rem;
  border-radius: 12px;
  border-bottom: 1px solid #f3f4f6;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);
  width: calc(50% - 0.6rem);
  cursor: pointer;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CardInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const Text = styled(Text16Regular)`
  line-height: 1.8rem;
  letter-spacing: -0.5px;
`;
export const Label = styled(Text)`
  opacity: 0.5;
`;

export const Avatar = styled.div`
  border-radius: 1000px;
  border: 1px solid #fff;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  color: #092f4d;
  text-align: center;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: -0.12px;
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 5.6rem);
`;

export const InfiniteScrollMarker = styled.div`
  height: 1rem;
`;

export const LoaderMoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
